import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import ReactHtmlParser from 'react-html-parser';
import { Box, Heading, Paragraph, BackgroundImage, Button } from 'components';
import './BoxDiscover.scss';

class BoxDiscover extends Component {
  render() {
    const {
      background,
      backgroundColor,
      headline,
      description,
      color,
      buttonText,
      link,
      additionalClass,
      externalLink,
      id,
    } = this.props;

    return (
      <Box
        link={link}
        id={id}
        additionalClass={`box-discover ${additionalClass}`}
        backgroundColor={backgroundColor}
      >
        <div className={'box-discover__content'}>
          <Heading color={color} size={'big'} type={3}>
            {ReactHtmlParser(headline)}
          </Heading>
          <Paragraph
            color={color}
            additionalClass={'text--light box-discover__description'}
            spaced
          >
            {description}
          </Paragraph>
        </div>
        {background && (
          <LazyLoad once offset={200} height={300}>
            <BackgroundImage
              src={background}
              additionalClass={'box-discover__background'}
            />
          </LazyLoad>
        )}
        <div className={'box-discover__footer'}>
          {externalLink ? (
            <Button color={color} transparent>
              {buttonText}
            </Button>
          ) : (
            <Button order={'secondary'} color={color}>
              {buttonText}
            </Button>
          )}
        </div>
      </Box>
    );
  }
}

BoxDiscover.defaultProps = {
  buttonText: 'Read more',
  background: '',
  description: '',
  additionalClass: '',
  color: 'black',
  backgroundColor: '',
  id: '',
  link: '',
  externalLink: false,
};

BoxDiscover.propTypes = {
  buttonText: PropTypes.string,
  background: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  additionalClass: PropTypes.string,
  color: PropTypes.string,
  headline: PropTypes.string.isRequired,
  id: PropTypes.string,
  link: PropTypes.string,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
  externalLink: PropTypes.bool,
};

export default BoxDiscover;
